<template>
    <v-dialog-old ref="dialog" id="doctorConfirmDialog">
        <DoctorCancelDialog ref="doctorCancelDialog" @canceled="updated"/>
        <fieldset>
            <legend>Заявка</legend>

            <table class="grid">
                <tr>
                    <td colspan="2">
                        <input type="text" v-model="doctorUser.username" class="large">
                        <label>URL</label>
                        <input type="text" v-model="doctorUser.doctu_url" class="large">
                    </td>
                </tr>
                <tr>
                    <td>
                        <label>Email</label>
                        <input type="text" v-model="doctorUser.email">
                    </td>
                    <td>
                        <label>Телефон</label>
                        <input v-model-phone="doctorUser.phone">
                    </td>
                </tr>
                <tr>
                    <td>
                        <label>Стаж</label>
                        <input type="text" v-model="doctorUser.user_info.experience" disabled>
                    </td>
                    <td>
                        <label>Место работы</label>
                        <input type="text" v-model="doctorUser.user_info.workPlace" disabled>
                    </td>
                </tr>
                <tr>
                    <td>
                        <label>Город</label>
                        <input type="text" v-model="doctorUser.city.name" disabled>
                    </td>
                    <td>
                        <label>Специализации</label>
                        <input type="text" v-model="doctorUser.specialitiesAsText" disabled>
                    </td>
                </tr>
                <tr>
                    <td>&nbsp;
                        <span class="comma">
                        <a :href="'/storage.secure/' + filename" v-for="filename in doctorUser.files" target="_blank">
                            <i class="fa fa-user" v-if="filename.includes('/photo/')"></i>
                            <i class="fa fa-file" v-else></i>&nbsp;{{ filename.replace(/^.*[\\\/]/, '') }}
                        </a>
                    </span>
                    </td>
                    <td align="right">
                        <button v-if="$can('admin.moderation.doctorsConfirm.update')"
                                class="small"
                                @click="searchDoctor">
                            Найти врача
                        </button>
                    </td>
                </tr>
            </table>
        </fieldset>

        <fieldset style="width:100%" class="">
            <legend>Врач</legend>
            <table class="grid">
                <tr>
                    <td rowspan="5" width="150" valign="top">
                        <img class="avatar"
                             :src="M.img ? '/storage.public/images/doctors/150x225/' + M.img : ''"
                             style="width:150px; height:225px; cursor:pointer; background-size: contain;"
                             :style="{'background-image': (M.sex === 'FEMALE' ? 'url(/_assets/pic_she.svg)' : 'url(/_assets/pic_he.svg)')}"
                        />

                        <a class="button small"
                           :href="'https://doctu.ru/' + M.cityCharId + '/doctor/' + M.url"
                           v-tooltip="'https://doctu.ru<br/>/' + M.cityCharId + '/doctor/' + M.url"
                           target="_blank"
                           width="150"
                           :disabled="!M.id"
                        >
                            <i class="fa fa-link"></i>
                            Показать на сайте
                        </a>
                    </td>
                    <td colspan="3">
                        <label>Фамилия</label>
                        <input class="large" type="text" v-model="M.nameFamily" readonly />
                    </td>
                </tr>
                <tr>
                    <td colspan="3">
                        <label>Имя</label>
                        <input class="large" type="text" v-model="M.nameFirst" readonly />
                    </td>
                </tr>

                <tr>
                    <td colspan="3">
                        <label>Отчество</label>
                        <input class="large" type="text" v-model="M.nameFathers" readonly />
                    </td>
                </tr>

                <tr>
                    <td>
                        <label>Специализация</label>
                        <div id="specialities_ids">
                            <input type="text" v-model="M.specialitiesAsText" readonly>
                        </div>

                    </td>
                    <td width="70">
                        <label>Стаж</label>
                        <input type="number" v-model="M.experience" v-units.literal="`лет`" min="0" max="100" style="text-align: center !important;" readonly />
                    </td>
                    <td width="100">
                        <label>Пол</label>
                        <v-select v-model="M.sex"
                                  readonly
                                  disabled
                                  :options="[
                                      { value: '', text: '\u00a0' },
                                      { value: 'MALE', text: 'Мужской' },
                                      { value: 'FEMALE', text: 'Женский' },
                                  ]"
                        />
                    </td>
                </tr>

                <tr>
                    <td colspan="3">
                        <label>Города</label>

                        <div class="textarea" disabled>
                        <span class="comma">
                            <span v-for="city in doctorCities">{{ city }}</span>
                        </span>
                        </div>
                    </td>
                </tr>
            </table>
        </fieldset>

        <fieldset style="width:100%">
            <legend>Места приема</legend>

            <table class="grid">
                <tbody v-for="clinic in M.clinics" class="hover">
                <tr :class="{onmoderation: clinic.moderationNeeded, del: clinic.pivot_deleted_at !== null}">
                    <td>{{ clinic.cityObj.name }}</td>
                    <td width="20" align="center">
                        <i class="fa fa-book"
                           :class="[clinic.hasAbonSubscription && clinic.pivot_deleted_at === null ? 'text-success' : 'text-danger']"
                           v-tooltip="clinic.hasAbonSubscription ? 'Есть запись' : 'Нет записи'"/>
                    </td>
                    <td>
                        <template>
                            {{ clinic.name }}
                            <span class="comma brackets">
                                <span v-if="clinic.pivot_deleted_at !== null">клиника удалена</span>
                                <span v-if="!clinic.hasAbonSubscription">нет&nbsp;записи</span>
                                <span v-if="clinic.deleted_at">связь&nbsp;удалена</span>
                            </span>
                        </template>
                    </td>

                    <td width="100">
                        <input v-model="clinic.price" disabled min="0" v-units.literal="`руб`" style="text-align: right" />
                    </td>
                </tr>
                </tbody>
            </table>
        </fieldset>

        <footer v-if="doctorUser.status === 20">
            <template v-if="$can('admin.moderation.doctorsConfirm.update')">
                <v-loading-component @click="confirm">
                    <template slot-scope="{ loadingClass }">
                        <button :class="['green', loadingClass]" :disabled="!M.id">Связать заявку и врача</button>
                    </template>
                </v-loading-component>
                <button class="red" @click="cancel">Отказать</button>
            </template>

            <v-loading-component v-if="$can('admin.moderation.doctorsConfirm.delete')" @click="remove">
                <template slot-scope="{ loadingClass }">
                    <button :class="['redHover', loadingClass]">Удалить</button>
                </template>
            </v-loading-component>
        </footer>
    </v-dialog-old>
</template>

<script>
import DoctorCancelDialog from "@dialogs/doctorsConfirm/DoctorCancelDialog";

export default {
    components: {DoctorCancelDialog},
    data: function () {
        return {
            doctorUser: {
                id: '',
                username: '',
                email: '',
                phone: '',
                doctu_url: '',
                status: '',
                city: {
                    name: ''
                },
                user_info: {
                    experience: '',
                    workPlace: ''
                }
            },
            M: {
                id: '',
                nameFamily: '',
                nameFirst: '',
                nameFathers: '',
                suffix: '',
                sex: '',
                img: '',
                imgOriginalPath: '',
                specialities_ids: [],
                info: '',
                education: [{
                    year:       "",
                    univercity: "",
                    speciality: "",
                    grade:      ""
                }],
                certificates: [{
                    univercity: "",
                    year: [{value: ""}]
                }],
                associations: [{
                    association: ""
                }],
                clinics: []
            },
        };
    },
    methods: {
        resetDoctorUser() {
            this.doctorUser = {
                id: '',
                username: '',
                email: '',
                phone: '',
                doctu_url: '',
                status: '',
                city: {
                    name: ''
                },
                user_info: {
                    experience: '',
                    workPlace: ''
                }
            };
        },
        resetDoctor() {
            this.M = {
                id: '',
                nameFamily: '',
                nameFirst: '',
                nameFathers: '',
                suffix: '',
                sex: '',
                img: '',
                imgOriginalPath: '',
                specialities_ids: [],
                info: '',
                education: [{
                    year:       "",
                    univercity: "",
                    speciality: "",
                    grade:      ""
                }],
                certificates: [{
                    univercity: "",
                    year: [{value: ""}]
                }],
                associations: [{
                    association: ""
                }],
                clinics: []
            };
        },
        show(id) {
            this.resetDoctorUser();
            this.resetDoctor();

            return this.axios.post('doctorsConfirm/read/' + id).then(response => {
                Object.assign(this.doctorUser, response.data);

                if (!this.doctorUser.city) {
                    this.doctorUser.city = {
                        name: ''
                    };
                }
                if (!this.doctorUser.user_info) {
                    this.doctorUser.user_info = {
                        experience: '',
                        workPlace: ''
                    };
                }

                if (response.data.doctu_url && response.data.status === 20) {
                    this.searchDoctor().then(() => this.$refs.dialog.show().then(() => this.initPhone()));
                } else if (response.data.doctu_url) {
                    this.getDoctor(id).then(() => this.$refs.dialog.show().then(() => this.initPhone()));
                } else {
                    this.$refs.dialog.show().then(() => this.initPhone());
                }
            });
        },
        searchDoctor() {
            return this.axios.post('doctorsConfirm/searchDoctor', this.doctorUser).then(response => {
                if (response.data.id) {
                    Object.assign(this.M, response.data);

                    if (this.doctorUser.doctu_url !== response.data.url) {
                        this.doctorUser.doctu_url = response.data.url
                    }
                } else {
                    this.resetDoctor();
                    this.$modal('Врач не найден.',{
                        name: 'ОК',
                        callback: () => {},
                    }, {}, false, 'only-text-dialog');
                }
            });
        },

        getDoctor(doctorUserId) {
            return this.axios.post('doctorsConfirm/getDoctor/' + doctorUserId).then(response => {
                if (response.data.id) {
                    Object.assign(this.M, response.data);
                } else {
                    this.resetDoctor();
                    this.$modal('Врач не найден.',{
                        name: 'ОК',
                        callback: () => {},
                    }, {}, false, 'only-text-dialog');
                }
            });
        },

        confirm(btn) {
            if (!this.M.id) {
                return;
            }
            btn.startLoadingAnimation();

            this.axios.post('doctorsConfirm/confirm', {
                id: this.doctorUser.id,
                url: this.M.url,
            }).then(response => {
                btn.stopLoadingAnimation();

                this.updated();
            }).catch(() => btn.stopLoadingAnimation());
        },

        cancel() {
            this.$refs.doctorCancelDialog.show({
                doctorUserId: this.doctorUser.id,
                doctorUrl: this.M.url,
            });
        },

        updated() {
            this.$refs.dialog.hide();
            this.$emit('updated');
        },

        remove(btn) {
            this.$modal('Удалить заявку?', {
                    name: 'Удалить',
                    btnClass: 'red',
                    callback: () => {
                        btn.startLoadingAnimation();

                        this.axios.post('doctorsConfirm/delete/' + this.doctorUser.id, {url: this.M.url})
                            .then(response => {
                                btn.stopLoadingAnimation();

                                this.updated();
                            }).catch(() => btn.stopLoadingAnimation());
                    }
                },
                {
                    name: 'Нет'
                }
            );
        },

        initPhone() {
            this.$nextTick().then(() => {
                this.doctorUser.phone = this.doctorUser.phone + ' ';
            })
        },
    },
    computed: {
        doctorCities() {
            return this.M.clinics.length ? [...new Set(
                this.M.clinics.map(row => {
                    return row.cityObj.name;
                })
            )] : [];
        },
    },
}
</script>

<style>
#doctorConfirmDialog {
    width: 950px;
}
</style>
